<ms-help-box
    *ngIf="isReBetHelpBoxVisible"
    [disableInfoIcon]="true"
    [boxType]="reBetHelpBoxType"
    (closeButtonClick)="onReBetHelpBoxClose()"></ms-help-box>
